function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { noop } from "lodash-es";
import { useIcon } from "../../helpers";
const Button = /*#__PURE__*/React.forwardRef(({
  id,
  onClick,
  size,
  outline,
  variant,
  disabled,
  icon,
  as: AsComponent,
  isLoading,
  buttonProps,
  badge,
  ...props
}, ref) => {
  const iconToRender = useIcon(icon.render);
  const ButtonComponent = disabled ? "button" : AsComponent;
  let btnProps = {
    ...buttonProps
  };
  btnProps.type = btnProps.type || (ButtonComponent === "button" ? "button" : undefined);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    ref: ref,
    id: id,
    role: "button",
    className: `button-wrapper ${props.className}`,
    tabIndex: disabled ? "-1" : "0",
    style: {
      display: "inline-block",
      ...props.style
    },
    onKeyPress: e => {
      if (e.key === "Enter" && !disabled) {
        onClick(e);
      }
    }
  }), /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, btnProps, {
    tabIndex: "-1",
    className: classNames(`tui-btn ${size} ${variant}`, {
      outline,
      "icon-only": props.children === null,
      "icon-left": icon.type === "left",
      "icon-right": icon.type === "right"
    }),
    onClick: !disabled ? onClick : undefined,
    disabled: disabled || isLoading,
    "aria-busy": isLoading
  }), /*#__PURE__*/React.createElement("span", {
    className: "tui-btn-content"
  }, icon.type !== "right" && iconToRender, badge.type !== "right" && badge.render, props.children, icon.type === "right" && iconToRender, badge.type === "right" && badge.render, isLoading && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    className: "loading-spinner"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45",
    className: "spinner"
  })))));
});
Button.displayName = "Button";
Button.defaultProps = {
  id: "",
  className: "",
  style: {},
  size: "md",
  outline: false,
  variant: "primary",
  disabled: false,
  isLoading: false,
  icon: {
    type: "",
    render: undefined
  },
  badge: {
    type: "",
    render: undefined
  },
  children: null,
  onClick: noop,
  as: "button",
  buttonProps: {}
};
Button.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.string,
  outline: PropTypes.bool,
  variant: ({
    variant,
    outline
  }, _key, componentName, _location, propFullName) => {
    if (typeof variant !== "string") {
      return Error(`Invalid prop ${propFullName} supplied to ${componentName}. Expected a string.`);
    }
    if (outline && variant === "white") {
      return Error(`Outline buttons do not have a "white" variant`);
    }
  },
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  icon: PropTypes.shape({
    type: PropTypes.string,
    render: PropTypes.func
  }),
  badge: PropTypes.shape({
    type: PropTypes.string,
    render: PropTypes.element
  }),
  children: PropTypes.node,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  buttonProps: PropTypes.object
};
export default Button;
//# sourceMappingURL=Button.js.map